export const sv = {
  headingFallback: 'Rubrik',
  pageTitle: 'Annonser',
  pageSubtitle: 'Visas som en bildslider på din profilsida i appen',
  newAd: 'Ny annons',
  statActiveNow: 'Aktiva nu',
  statScheduled: 'Schemalagda',
  statInactive: 'Inaktiva',
  emptyTitle: 'Inga annonser ännu',
  emptyDescription: 'Skapa en annons som visas i appen på din profilsida.',
  createFirst: 'Skapa din första annons',
  statusLive: 'Live',
  statusScheduled: 'Schemalagd',
  statusInactive: 'Inaktiv',
  edit: 'Redigera',
  deactivate: 'Inaktivera',
  activate: 'Aktivera',
  modalTitleEdit: 'Redigera annons',
  modalTitleNew: 'Ny annons',
  cancel: 'Avbryt',
  saveChanges: 'Spara ändringar',
  createAd: 'Skapa annons',
  preview: 'Förhandsgranskning',
  template: 'Mall',
  titleLabel: 'Rubrik *',
  titlePlaceholder: 't.ex. Sommarerbjudande – 20% rabatt',
  descriptionLabel: 'Beskrivning',
  descriptionPlaceholder: 'Kort text under rubriken (valfri)',
  ctaTextLabel: 'Knapptext',
  ctaTextPlaceholder: 't.ex. Boka nu',
  ctaUrlLabel: 'Länk (URL)',
  startDateLabel: 'Startdatum *',
  endDateLabel: 'Slutdatum *',
  priorityLabel: 'Prioritet',
  adIsActive: 'Annonsen är aktiv',
}

export const en: typeof sv = {
  headingFallback: 'Heading',
  pageTitle: 'Ads',
  pageSubtitle: 'Shown as an image slider on your profile page in the app',
  newAd: 'New ad',
  statActiveNow: 'Active now',
  statScheduled: 'Scheduled',
  statInactive: 'Inactive',
  emptyTitle: 'No ads yet',
  emptyDescription: 'Create an ad that is shown in the app on your profile page.',
  createFirst: 'Create your first ad',
  statusLive: 'Live',
  statusScheduled: 'Scheduled',
  statusInactive: 'Inactive',
  edit: 'Edit',
  deactivate: 'Deactivate',
  activate: 'Activate',
  modalTitleEdit: 'Edit ad',
  modalTitleNew: 'New ad',
  cancel: 'Cancel',
  saveChanges: 'Save changes',
  createAd: 'Create ad',
  preview: 'Preview',
  template: 'Template',
  titleLabel: 'Heading *',
  titlePlaceholder: 'e.g. Summer offer – 20% off',
  descriptionLabel: 'Description',
  descriptionPlaceholder: 'Short text under the heading (optional)',
  ctaTextLabel: 'Button text',
  ctaTextPlaceholder: 'e.g. Book now',
  ctaUrlLabel: 'Link (URL)',
  startDateLabel: 'Start date *',
  endDateLabel: 'End date *',
  priorityLabel: 'Priority',
  adIsActive: 'The ad is active',
}
